import React from 'react';

class BetgamesSidebarWidgetContainer extends React.Component {
    _timeoutId = null;
    componentDidMount() {
        const _bt2 = _bt2 || [];

        _bt2.push(['server', 'https://widget02.betgames.tv']);
        _bt2.push(['partner', 'fairplay_kz']);
        _bt2.push(['token', '-']);
        _bt2.push(['language', 'ru']);
        _bt2.push(['currency', 'kzt']);
        _bt2.push(['iframe_url', 'https://www.fp.kz/betgames']);

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `https://widget02.betgames.tv/js/betgames-widget.js?ts=${Date.now()}'`;
        const parent = document.getElementById('BetGamesWidget_div_iframe');
        parent.appendChild(script);

        this._timeoutId = window.setTimeout(() => {
            window.BetGamesWidget.frame(_bt2);
        }, 3000);
    }

    componentWillUnmount() {
        if (this._timeoutId !== null) {
            window.clearTimeout(this._timeoutId);
        }
    }

    render() {
        return (
            <div id='BetGamesWidget_div_iframe' />
        )
    }
}

export default BetgamesSidebarWidgetContainer;


// WEBPACK FOOTER //
// ./js/sport-betting/components/betgames/BetgamesSidebarWidgetContainer.jsx